import React, { FC } from 'react'

interface DotsProps {
    className?: string,
    width: string,
    height: string
}

const Dots: FC<DotsProps> = ({ className, width, height }) => {
    return (
        <div className={`flex gap-6 ${className}`}>
            <div className={`${width} ${height} bg-yellow rounded-full`}></div>
            <div className={`${width} ${height} orange-bg rounded-full`}></div>
            <div className={`${width} ${height} bg-purple rounded-full`}></div>
        </div>
    )
}

export default Dots
